import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { push } from "react-router-redux";

import { setDialogStatus } from "../../redux/modules/ui/ui";

const s = require("./menu.scss");

interface IMenuProps {
    dispatch?: Dispatch<any>;
};

interface IMenuState {};

class Menu extends React.Component<IMenuProps, IMenuState> {
    onLogout() {
        if (!confirm("Você tem certeza que deseja sair?")) {
            return;
        }

        this.props.dispatch({
            type: "USER_LOGOUT"
        });
        this.props.dispatch(push("/login"));
    }

    openTermsOfUseDialog() {
        this.props.dispatch(setDialogStatus("termsOfUseDialog", true));
    }

    openDoctorsDialog() {
        this.props.dispatch(setDialogStatus("doctorsDialog", true));
    }

    public render(): JSX.Element {
        return (
            <nav className={s.menu}>
                <ul>
                    {/*<li>Como funciona</li>
                    <li>Contato</li>*/}
                    <li onClick={event => this.openDoctorsDialog()}>Profisionais</li>
                    <li onClick={event => this.openTermsOfUseDialog()}>Termos de uso</li>
                    <li onClick={event => this.onLogout()}>Sair</li>
                </ul>
            </nav>
        );
    }
}

export default connect()(Menu);



// WEBPACK FOOTER //
// ./src/containers/Menu/index.tsx